export default __webpack_public_path__ + "static/media/phone.a0ffeb58.svg";